import Presentation from "./presentation";

const EditSettingsMenuFooter = ( {
	onSubmit,
	onCancel,
	hideCancelBtn,
	submitBtnText,
	cancelBtnText,
	hideSubmitBtn,
	containerClass,
	disabled = false
} ) => {
	return (
		<Presentation
			cancelBtnText  = { cancelBtnText }
			containerClass = { containerClass }
			disabled       = { disabled }
			hideCancelBtn  = { hideCancelBtn }
			hideSubmitBtn  = { hideSubmitBtn }
			onCancel       = { onCancel }
			onSubmit       = { onSubmit }
			submitBtnText  = { submitBtnText }
		/>
	);
};

export default EditSettingsMenuFooter;